import http from "./http";

const getfacultyList = async () => {
  const faculties = await http.post("/select/kafedra/list", {
  })
  return faculties.data
}

const getFEducList = async (idFaculty) => {
  const feducs = await http.post("/select/f_educ/list", {
    faculty: idFaculty
  })
  return feducs.data
}

const getRateList = async ( fEduc, idFaculty ) => {
  const rates = await http.post("/select/rate/list", {
    f_educ: fEduc, 
    fac: idFaculty
  })
  return rates.data
}
const getGroupList = async (year,
  faculty,
  fEduc,
  id_rate) => {
  const groups = await http.post("/select/group/list", {
    id_year: year,
    id_faculty: faculty,
    id_f_educ: fEduc,
    id_rate: id_rate
  })
  return groups.data
}

export {
  getfacultyList,
  getFEducList,
  getRateList,
  getGroupList
};
